export default "__VITE_ASSET__0555a7f4__"